module.exports = __webpack_public_path__ + "static/img/device_s2_max.49ff973c.png";